import styled from 'styled-components/macro';

const Link = styled.a`
  color: inherit;
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
`;

export default Link;
